import { render } from "./IntegrationSuccessInformation.vue?vue&type=template&id=ffafad24&scoped=true"
import script from "./IntegrationSuccessInformation.vue?vue&type=script&lang=js"
export * from "./IntegrationSuccessInformation.vue?vue&type=script&lang=js"

import "./IntegrationSuccessInformation.vue?vue&type=style&index=0&id=ffafad24&lang=scss&scoped=true"

import exportComponent from "C:\\laragon\\www\\runpixie_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffafad24"]])

export default __exports__